import { PhasrDetectedIncidentsWebComponent } from './component/PhasrDetectedIncidentsWebComponent';

export { PhasrDetectedIncidentsWebComponent };
